import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface ICreateFileRequestParams {
	/** The upload is attributed to this contact, so the link only works for them. */
	contactId: string;
	description?: string;
	name: string;
}

/**
 * Creates a standalone file request for one contact (`POST sharedFile/request`) and resolves with the short link
 * they upload through. Expiration is left to the account's default request-link setting.
 */
export function useCreateFileRequestMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ contactId, description, name }: ICreateFileRequestParams) =>
			userSession.webServiceHelper.callAsync<string>(
				// No impersonation route exists for this endpoint, so no impersonation context is accepted.
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { contactId },
					urlPath: 'sharedFile/request',
				}),
				'POST',
				{ _type: 'FileRequestSurvey', description: description?.trim() || undefined, name: name.trim() }
			),
	});
}
